/* eslint-disable camelcase */
import i18n from 'live/services/i18n'

import en_us from './en_us'
import pt_br from './pt_br'

export default ((): void => {
    const locale = window.Live.settings && window.Live.settings.locale ? window.Live.settings.locale : 'pt_br'
    const localeFiles = { pt_br, en_us }

    i18n.add(localeFiles[locale])
})()
